export const defaultFilters = {
  objectType: undefined,
  objectId: undefined,
  event: undefined,
  loggedAt: undefined,
  order_date: 'desc',
}
